import React, { memo } from 'react'
import { useIntl } from 'react-intl'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import sx from './styles'

const EasyCaracteristicsList = ({ data }) => {
  const { formatMessage: f } = useIntl()
  return (
    <Grid
      size={12}
      container
      sx={sx.gridContainer}
      flexDirection="row"
    >
      {data.map(({ id, description, icon }) => (
        <Grid
          size={{
            xs: 12,
            md: 5,
            lg: 2,
          }}
          key={`list-item-${id}`}
          sx={sx.gridlist}
        >
          {icon}
          <Typography
            variant="h3"
            sx={sx.itemDescription}
          >
            {f({ id: description })}
          </Typography>
        </Grid>
      ))}
    </Grid>
  )
}

export default memo(EasyCaracteristicsList)
